module.exports = __webpack_public_path__ + "static/media/pricingbanner.b1bdb964.svg";